module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', [_c('div', {
    staticClass: "container main-notes"
  }, [_c('div', {
    staticClass: "form-container"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('h5', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(("" + _vm.domainName)))]), _vm._v(" "), _c('span', {
    staticClass: "pull-right",
    attrs: {
      "id": "svgContainer"
    },
    on: {
      "click": function($event) {
        return _vm.addnote()
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-plus-circle fa-w-16 fa-2x",
    attrs: {
      "width": "18px",
      "height": "18px",
      "aria-hidden": "true",
      "data-prefix": "fal",
      "data-icon": "plus-circle",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M384 250v12c0 6.6-5.4 12-12 12h-98v98c0 6.6-5.4 12-12 12h-12c-6.6 0-12-5.4-12-12v-98h-98c-6.6 0-12-5.4-12-12v-12c0-6.6 5.4-12 12-12h98v-98c0-6.6 5.4-12 12-12h12c6.6 0 12 5.4 12 12v98h98c6.6 0 12 5.4 12 12zm120 6c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-32 0c0-119.9-97.3-216-216-216-119.9 0-216 97.3-216 216 0 119.9 97.3 216 216 216 119.9 0 216-97.3 216-216z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "notes-text"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "Please input notes"
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addnote($event)
      }
    },
    model: {
      value: (_vm.notesInput),
      callback: function($$v) {
        _vm.notesInput = $$v
      },
      expression: "notesInput"
    }
  })], 1)]), _vm._v(" "), (_vm.notes.length > 0) ? _c('div', [_c('ul', _vm._l((_vm.notes.slice().reverse()), function(not, index) {
    return _c('li', [_c('span'), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "title first-name"
    }, [_vm._v(_vm._s(("" + (not.created_by.first_name))))]), _vm._v(" "), _c('div', {
      staticClass: "type"
    }, [_vm._v(_vm._s(("" + (not.note))))])]), _vm._v(" "), _c('span', {
      staticClass: "number"
    }, [_c('span', [_c('span', {
      staticClass: "notes-time"
    }, [_vm._v(_vm._s(_vm._f("moment")(("" + (not.created)), "MMM Do, h:mm:ss a")))])]), _vm._v(" "), _c('span')])])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        return _vm.stepBack()
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6973526e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/admin/Notes.vue
// module id = 702
// module chunks = 2